import styled from 'styled-components';
import { EmojiPickerIconContainer } from '../plugins/emoji';

export const IdeasEmojiPickerIconContainer = styled(EmojiPickerIconContainer)`
  top: 40px;
  right: 40px;
  background: #ffffff;
`;
